export const UX_COPY_IT = {
  "quickNavAria": "Navigazione rapida delle sezioni",
  "skipToSections": "Vai alle sezioni della pagina",
  "jumpToStudioHint": "Scorciatoia: Alt + S"
};

export const TRIAL_FLOW_COPY_IT = {
  "flowLabel": "Cosa succede dopo",
  "flowSteps": [
    "Scegli un’immagine per una prova rapida.",
    "Metadata Studio si apre con il marketplace già selezionato.",
    "Rivedi e modifica il risultato prima di esportarlo."
  ]
};

export const LANDING_SALES_COPY_IT = {};


export default LANDING_SALES_COPY_IT;
